import { render, staticRenderFns } from "./Usda_link_modal.vue?vue&type=template&id=27c3ccc0&scoped=true&"
import script from "./Usda_link_modal.vue?vue&type=script&lang=js&"
export * from "./Usda_link_modal.vue?vue&type=script&lang=js&"
import style0 from "./Usda_link_modal.vue?vue&type=style&index=0&id=27c3ccc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c3ccc0",
  null
  
)

export default component.exports